export const CHAT_SERVICE = "ChatService";